import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import { style, WEB_URL } from "variables/Variables.jsx";
import routes from "routes.js";

import image from "assets/img/sidebar-3.jpg";

class Admin extends Component {
  state = {
    userLoggedIn : false,
    authEmail : null,
    authDetail : null,
    _notificationSystem: null,
    image: image,
    color: "black",
    hasImage: true,
    fixedClasses: "dropdown show-dropdown open"
  };

  constructor(props) {
    super(props);

    if(!this.state.userLoggedIn){
      if(!this.onValidNonAuthenticatedPage()){
        //this.props.history.replace('/home/login');

        fetch("https://"+WEB_URL+"/account/api/login",{
          'method' : 'POST',
          'headers' : { 'Content-Type' : 'application/json'},
          'body' : JSON.stringify({'email':'','password':'','detail':true}),
          'credentials': 'same-origin'
        }).then(res => res.json())
          .then(
            (result) => {
              if(result.auth == 'AUTH_OK' && result.token){
                this.setLoggedIn(result,this.state.email,true);
              }else{
                this.setLoggedIn(false);    
                this.props.history.replace('/home/login');
              }
            },
            (error) => {
              this.setLoggedIn(false);
              this.props.history.replace('/home/login');
            }
          )
      }
    }
  }

  onValidNonAuthenticatedPage(){
    return  this.props.history.location.pathname.indexOf('forgotpassword')>-1 || 
            this.props.history.location.pathname.indexOf('/home/login')==0 || 
            this.props.history.location.pathname.indexOf('/reset-password')>-1 ||
            this.props.history.location.pathname.indexOf('/confirm-email')>-1
            ;
  }

  setLoggedIn = (authObj,email,stayOnPage) => {
    if(authObj){
      this.setState({ userLoggedIn :  true, authDetail : authObj, authEmail : email });

      if(!stayOnPage){
        this.props.history.push('/home/user');      
      }
    }else{
      this.setState({ userLoggedIn :  false, authDetail : null });

      if(!this.onValidNonAuthenticatedPage()){
        this.props.history.push('/home/login');      
      }
    }
  }

  handleNotification = (level,position,message) => {
    var color = Math.floor(Math.random() * 4 + 1);
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: (
        <div>
          {message}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15
    });
  };

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/home" && this.state.userLoggedIn == prop.loggedInComponent) {
        return (
          <Route
            path={prop.layout + prop.path}
            render={props => (
              <prop.component
                {...props}
                triggerNotification={this.handleNotification}
                setLoggedIn={this.setLoggedIn}
                authDetail={this.state.authDetail}
                authEmail={this.state.authEmail}
              />
            )}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "FlowPaper Account Area";
  };
  handleImageClick = image => {
    this.setState({ image: image });
  };
  handleColorClick = color => {
    this.setState({ color: color });
  };
  handleHasImage = hasImage => {
    this.setState({ hasImage: hasImage });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show-dropdown open" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var _notificationSystem = this.refs.notificationSystem;
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    // _notificationSystem.addNotification({
    //   title: <span data-notify="icon" className="pe-7s-gift" />,
    //   message: (
    //     <div>
    //       Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
    //       every web developer.
    //     </div>
    //   ),
    //   level: level,
    //   position: "tr",
    //   autoDismiss: 15
    // });
  }
  componentDidUpdate(e) {
    if(this.props.location.pathname.endsWith('logout')){
      this.setLoggedIn(false);
      this.props.history.replace('/home/login');
    }

    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    return (window.location.href.indexOf('?route=dtp')==-1?
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} userLoggedIn={this.state.userLoggedIn} routes={routes} image={this.state.image}
        color={this.state.color}
        hasImage={this.state.hasImage}/>
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>{this.getRoutes(routes)}</Switch>
          <Footer />
        </div>
      </div>
    :<div className="wrapper">
      <NotificationSystem ref="notificationSystem" style={style} />
      <div id="main-panel" ref="mainPanel" style={{marginTop:20}}>
        <Switch>{this.getRoutes(routes)}</Switch>
      </div>
    </div>);
  }
}

export default Admin;
